// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type FuhrparkeintragAnbauteilPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheFuhrparkeintragAnbauteilQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheFuhrparkeintragAnbauteil(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  query: SucheFuhrparkeintragAnbauteilQuery
) => Promise<FuhrparkeintragAnbauteilPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, query = {}) =>
      (await getAPI()).fuhrparkeintraganbauteile.sucheFuhrparkeintragAnbauteil({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        ...query,
      }),
    [getAPI]
  );
}
